import { CollectionView } from '@grapecity/wijmo';
import * as React from 'react';

import * as wjChart from '@grapecity/wijmo.react.chart';
import * as wjGrid from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';

import { Col, Row, Container } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';

import './Analysis.css';

// 分析（契約単価）（工事／管・小）
function AnalysisKingakuTankaBigSmall(props) {
  // 契約情報リスト
  const [keiyakuList, setKeiyakuList] = useState(new CollectionView([]));
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // グリッドのキー
  const [gridKey, setGridKey] = useState(0);

  useEffect(() => {
    setKeiyakuList(
      new CollectionView(
        props.keiyakuList.items.map((x) => ({
          ...x,
        }))
      )
    );
  }, [props.keiyakuList]);

  //  グリッドの初期化
  function onInitialized(grid) {
    // ヘッダーを2段にする
    var extraRow = new wjGrid.Row();
    extraRow.cssClassAll = 'header-center';
    extraRow.allowMerging = true;
    var panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);
    panel.setCellData(0, 0, '月');
    for (var i = 1; i < grid.columns.length; i++) {
      panel.setCellData(0, i, '契約金額・契約単価');
    }

    grid.formatItem.addHandler((sender, e) => {
      // フッターセルのスタイル設定
      if (e.panel === sender.columnFooters) {
        const colIndex = e.col;
        const rowIndex = e.row;

        // フッターの1行目の線を太くする
        if (rowIndex === 0) {
          e.cell.style.borderTop = 'double';
        }

        if (rowIndex == 0 && [1].includes(colIndex)) {
          // 工事
          e.cell.style.backgroundColor = '#d9e1f2';
        } else if (rowIndex == 0 && [3].includes(colIndex)) {
          // 小工事
          e.cell.style.backgroundColor = '#ffff99';
        } else {
          // 他のセルの背景色をデフォルトに戻す
          e.cell.style.backgroundColor = '';
        }
      }
    });

    // フッターに１段追加
    grid.columnFooters.rows.push(new wjGrid.Row());

    // データ変更時に合計更新
    grid.collectionView.collectionChanged.addHandler(updateFooter);
    updateFooter(grid);
  }

  // 合計値を計算してフッターに設定
  function updateFooter(grid) {
    let data = grid?.itemsSource?.items;
    if (!data || data.length === 0) return;

    let panel = grid.columnFooters;

    // 月
    panel.setCellData(0, 0, '合計');
    panel.setCellData(1, 0, '今月まで');

    // 工事
    const bigTotal = data.reduce((sum, item) => sum + (item['KIN_BIG_TOTAL'] || 0), 0);
    panel.setCellData(0, 1, bigTotal);

    // 工事の契約単価
    const bigCount = data.reduce((sum, item) => sum + (item[`KEI_BIG_TOTAL`] || 0), 0);
    const bigUnitPrice = bigTotal / bigCount;
    panel.setCellData(0, 2, bigUnitPrice);

    // 小工事の合計
    const smallTotal = data.reduce((sum, item) => sum + (item['KIN_SMALL_TOTAL'] || 0), 0);
    panel.setCellData(0, 3, smallTotal);

    // 小工事の契約単価
    const smallCount = data.reduce((sum, item) => sum + (item[`KEI_SMALL_TOTAL`] || 0), 0);
    const smallUnitPrice = smallTotal / smallCount;
    panel.setCellData(0, 4, smallUnitPrice);
  }

  return (
    <Container fluid className="p-0">
      <Row className="mt-2">
        <Col className="pl-3" md="7">
          <FlexGrid
            key={gridKey}
            isReadOnly={true}
            allowMerging="ColumnHeaders"
            allowSorting={false}
            allowDragging={false}
            itemsSource={keiyakuList}
            headersVisibility={'Column'}
            alternatingRowStep={0}
            initialized={onInitialized}
          >
            <FlexGridColumn
              binding="MONTH"
              header="月"
              allowMerging={true}
              width={60}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_BIG_TOTAL"
              cssClass="big_cell"
              header="工事"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="BIG_UNIT_PRICE"
              header={`契約単価`}
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_SMALL_TOTAL"
              cssClass="small_cell"
              header="管・小"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="SMALL_UNIT_PRICE"
              header={`契約単価`}
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
          </FlexGrid>
        </Col>
        <Col className="pl-3" md="5">
          <wjChart.FlexChart
            header="移動年計　契約金額"
            itemsSource={keiyakuList.sourceCollection}
            bindingX="MONTH"
            chartType="Line"
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
          >
            {/* Y軸の最大・最小値を設定 */}
            <wjChart.FlexChartAxis wjProperty="axisY" min={0} />
            {/* X軸にY方向のグリッド線を表示 */}
            <wjChart.FlexChartAxis wjProperty="axisX" majorGrid={true} />
            {/* 凡例の位置を下に配置 */}
            <wjChart.FlexChartLegend position="Bottom" />
            <wjChart.FlexChartSeries name="工事" binding="KIN_BIG_TOTAL" />
            <wjChart.FlexChartSeries name="管・小" binding="KIN_SMALL_TOTAL" />
          </wjChart.FlexChart>
        </Col>
      </Row>
    </Container>
  );
}
export default AnalysisKingakuTankaBigSmall;
